<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<span class="int_type mgr_5">
					<select v-model="closed_yn" class="tbl_select sm_int" @change="selectPromotions()">
						<option v-for="tag in this.$closedTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_tbl" style="height: 795px; overflow-y: auto;">
				<table id="item_list" class="list_tbl tbl_pointer" v-columns-resizable>
					<thead>
						<tr>
							<th style="text-align:center;width:30px;">Group</th>
							<th style="text-align:center;">Title</th>
							<th style="text-align:center;width:120px;">From Date</th>
							<th style="text-align:center;width:120px;">To Date</th>
							<th style="text-align:center;width:120px;">Check Sale Date</th>
							<th style="text-align:center;width:30px;">Closed</th>
							<!-- <th style="text-align:center;width:50px;">Items</th> -->
						</tr>
					</thead>

					<tbody>
						<tr v-for="pm in promotions" v-bind:key="pm.pm_no" v-bind:class="{ on: pm.pm_no == selectedPromotion.pm_no }" @click="selectRow(pm)">
							<td style="text-align:center;">{{ pm.group_no }}</td>
							<td class="truncate">
								<span :title="pm.title">{{ pm.title }}</span>
							</td>
							<td style="text-align:left;">{{ pm.from_date }}</td>
							<td style="text-align:left;">{{ pm.to_date }}</td>
							<td style="text-align:left;">{{ pm.from_sale_date }}</td>
							<td style="text-align:center;">{{ pm.closed_yn }}</td>
							<!-- <td style="text-align:right;">{{ pm.item_count }}</td> -->
						</tr>
					</tbody>
				</table>

				<div style="text-align:right;padding-top:5px;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

				<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

				<div class="view_bottom_bt">
					<a v-if="modifiable" href="javascript:;" :class="mode == 'add' ? 'disable_bt' : 'gray_bt'" @click="add()">Add</a>
				</div>
			</div>

			<div class="right_tbl" style="height: 795px; overflow-y: auto;">
				<h4 class="inner_h5">{{ detailTitle }}</h4>
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width:120px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>Title</th>
							<td><input type="text" v-model.trim="promotion.title" class="tbl_int full_int" /></td>
						</tr>
						<tr>
							<th>Group No</th>
							<td>
								<select class="tbl_select" style="width:95px;" v-model="promotion.group_no">
									<option :value="1">1</option>
									<option :value="2">2</option>
								</select>
							</td>
						</tr>
						<tr>
							<th>Promotion Period</th>
							<td><CustomDatePicker v-model="promotion.from_date" /> ~ <CustomDatePicker v-model="promotion.to_date" /></td>
						</tr>
						<tr>
							<th>Check Sale Date</th>
							<td><CustomDatePicker v-model="promotion.from_sale_date" /></td>
						</tr>
						<tr>
							<th></th>
							<td>
								<label for="closed_yn" style="margin-left:5px;"> <input type="checkbox" id="closed_yn" v-model="promotion.closed_yn" true-value="Y" false-value="N" />Closed</label>
							</td>
						</tr>
					</tbody>
				</table>

				<!-- #3312 4차 JC: 선택한 프로모션의 저장된 Classes Excel. 조회 기능이라 수정 권한(modifiable)과 분리한다. 비 JC 는 기존대로 modifiable 일 때만 이 영역과 Save 가 보인다. -->
				<div v-if="modifiable || is_jc" class="view_bottom_bt" style="padding-top:15px;">
					<a v-if="is_jc" href="javascript:;" class="gray_bt mgr_10" @click="excelClasses()">Excel</a>
					<a v-if="modifiable" href="javascript:;" :class="!isValid && mode != 'add' ? 'disable_bt' : 'search_bt'" @click="submit()">Save</a>
				</div>

				<h4 class="inner_h5">Classes</h4>
				<div class="view_bottom_bt" style="padding-top:10px;">
					<a v-if="modifiable && mode == 'detail' && selectedPromotion.pm_no" href="javascript:;" :class="mode == 'add' ? 'disable_bt' : 'search_bt'" @click="search()">Add Class</a>
				</div>

				<div class="fixed-table-container" style="height:445px;">
					<div class="table-wrapper" style="height:430px;">
						<table id="item_list" class="list_tbl tbl_pointer" border="0">
							<thead>
								<tr>
									<th width="150px;">
										<div class="th-text">{{ headers.class }} Code</div>
									</th>
									<th>
										<div class="th-text">{{ headers.class }} Name <a v-if="classes.length > 0" href="javascript:void(0)" class="gray_bt" style="margin-left:15px;" @click="copyName()">Copy to Title</a></div>
									</th>
									<th v-if="is_jc" width="80px;" class="al_center">
										<div class="th-text">Min Price</div>
									</th>
									<th v-if="is_jc" width="100px;" class="al_center">
										<div class="th-text">Promo Min</div>
									</th>
									<th width="100px;" class="al_center">
										<div class="th-text">Delete</div>
									</th>
									<!-- <th style="text-align:center;width:35%"><div class="th-text">Team</div></th>
											<th style="text-align:center;width:10%"><div class="th-text">Delete</div></th> -->
								</tr>
							</thead>

							<tbody>
								<tr v-for="(c, index) in classes" v-bind:key="c.class_code">
									<td>{{ c.class_code }}</td>
									<td>{{ c.class_name }}</td>
									<td v-if="is_jc" class="al_right">{{ c.item_min_price | toCurrency }}</td>
									<td v-if="is_jc" class="al_right">
										<currency-input type="text" v-model="c.promo_min_price" :precision="2" class="r_int long_type al_right" style="width:80px;" :disabled="!modifiable" :title="promoMinPriceHint(c)" @focus="$event.target.select()" />
									</td>
									<td class="al_center"><a href="javascript:void(0)" class="gray_bt" @click="deleteClass(index)">Delete</a></td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="view_bottom_bt">
						<span v-if="is_jc" style="float:left;line-height:24px;">Total Count : {{ classes.length | commaSeparated }}</span>
						<a v-if="modifiable" href="javascript:;" :class="!isValid ? 'disable_bt mgr_15' : 'gray_bt mgr_15'" @click="clearClasses()">Clear</a>
						<a v-if="modifiable" href="javascript:;" :class="!isValid ? 'disable_bt' : 'search_bt'" @click="saveClasses()">Save Class(es)</a>
					</div>
				</div>
			</div>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'ItemClass'" :draggable="false" @keydown.esc.prevent="test()" style="z-index:3000">
			<template slot="title">Select Item {{ headers.class }}</template>
			<template slot="body">
				<!-- #3196 jc 만 선택 후에도 팝업을 유지해 연속 선택. 다른 company 는 기존대로 1건 선택 시 닫힌다. -->
				<ItemClassPopup :code_only="false" :close_on_select="!is_jc" operation="S" v-on:close="closeModal()" @close="popupCanceled" @cancel="popupCanceled" @set-item-class2="setItemClass" />
			</template>
		</Modal>
	</div>
</template>

<script>
import { apiSelectPromotionList, apiInsertPromotion, apiUpdatePromotion, apiUpdatePromotionClasses, apiSelectPromotionClassList } from '@/api/sales/promotion.js';
// import CodeSelect from '@/components/common/CodeSelect';
// import UserPopup from '@/components/common/UserPopup';
import Modal from '@/components/common/Modal';
import ItemClassPopup from '@/components/common/ItemClassPopup';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import _ from 'lodash';
import Paging from '@/components/common/Paging';
import { exportDataExcel } from '@/api/util';
import { defaultDataType } from 'export-xlsx';
import '@/assets/css/table_box.css';

export default {
	data: function() {
		return {
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			closed_yn: 'N',
			mode: null,

			promotions: [],
			selectedPromotion: {},

			promotion: {},

			classes: [],

			selectedClass: {},
			modalName: '',
			showModal: false,
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		detailTitle() {
			return this.mode == 'add' ? 'Add' : 'Detail';
		},
		isValid() {
			if (!this.promotion.pm_no) return false;
			else return true;
		},
		headers: function() {
			return { class: this.$session.get('headerClass') };
		},
		// #3196 이번 요청(팝업 연속 선택 / 임시 Min Price / Total Count)은 jc 요구사항이며 jc 에서만 동작한다.
		// Promotion 화면은 hairplus·beautyplus 도 쓰는 공용 화면이므로 그 회사들의 기존 동작을 그대로 둔다.
		is_jc() {
			return this.user.company_id == 'jc';
		},
		modifiable() {
			if (this.user.admin_yn == 'Y') return true;

			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
	},
	components: {
		Paging,
		CustomDatePicker,
		// UserPopup,
		Modal,
		ItemClassPopup,
	},
	methods: {
		copyName() {
			if (this.classes.length > 0) {
				this.promotion.title = this.classes[0].class_name;
			}
		},
		popupCanceled() {},
		deleteClass(index) {
			this.classes.splice(index, 1);
		},
		closeModal() {
			this.showModal = false;
		},
		mergeClass(itemClass) {
			var foundClass = this.classes.filter(c => c.class_code == itemClass.class_code);
			if (foundClass.length > 0) return;

			var new_class = _.cloneDeep(itemClass);
			if (this.is_jc) {
				// #3196 Vue 2 반응성 확보를 위해 신규 행에도 키를 미리 만들어 둔다.
				// item_min_price 는 item class 조회에 없으므로 Save 후 재조회 시 채워진다.
				new_class.promo_min_price = null;
				new_class.item_min_price = null;
			}
			this.classes.push(new_class);
		},
		// #3196 임시 Min Price 입력 도움말(Item Master 기준가는 참조용)
		promoMinPriceHint(c) {
			if (c.item_min_price == null) return 'Must be greater than 0. Item Master Min Price is shown after saving';
			return 'Must be greater than 0';
		},
		// #3196 저장 전 임시 Min Price 검증.
		// 0 이하는 하한을 무력화하므로 막는다. Item Master Min Price 초과는 허용한다(2차 요청) —
		// 프로모션 기간 하한을 min_price 보다 살짝 높게 잡는 실사용 케이스가 있고, 서버·SO 화면 하한 공식은 이 값을 그대로 지원한다.
		validateClasses() {
			if (!this.is_jc) return null;

			for (var i = 0; i < this.classes.length; i++) {
				var c = this.classes[i];
				if (c.promo_min_price === null || c.promo_min_price === undefined || c.promo_min_price === '') continue;

				var promo_min = Number(c.promo_min_price);
				if (isNaN(promo_min) || promo_min <= 0) {
					return c.class_code + ' : Promo Min must be greater than 0';
				}
			}
			return null;
		},
		setItemClass(itemClass) {
			//this.search2(itemClass.code, null);
			itemClass.class_code = itemClass.code;
			itemClass.class_name = itemClass.name;

			//console.log(itemClass);
			this.mergeClass(itemClass);
		},
		async search() {
			this.modalName = 'ItemClass';
			this.showModal = true;
		},
		clearClasses() {
			this.classes = [];
		},
		async saveClasses() {
			var error = this.validateClasses();
			if (error) {
				this.$toast.error(error);
				return;
			}

			let param = {
				pm_no: this.selectedPromotion.pm_no,
				classes: this.classes,
			};
			//console.log(param);

			const { data } = await apiUpdatePromotionClasses(param);

			if (data.result) {
				this.$toast.success('Saved successfully');
				// #3196 저장분(임시 Min Price)과 Item Master Min Price 참조값을 화면에 반영. jc 전용.
				if (this.is_jc) await this.selectClasses(this.selectedPromotion.pm_no);
			} else {
				this.$toast.error(data.msg);
			}
		},
		async submit() {
			if (!this.isValid && this.mode != 'add') return;

			if (!this.promotion.title) {
				this.$toast.error('Empty Title');
				return;
			}

			if (!this.promotion.from_date) {
				this.$toast.error('Empty From Date');
				return;
			}

			if (!this.promotion.to_date) {
				this.$toast.error('Empty To Date');
				return;
			}

			if (!this.promotion.group_no) {
				this.$toast.error('Select Group No');
				return;
			}

			var response;
			if (this.mode == 'add') {
				response = await apiInsertPromotion(this.promotion);
			} else {
				response = await apiUpdatePromotion(this.promotion);
			}
			var data = response.data;

			if (data.result) {
				this.$toast.success('Saved successfully');
				if (this.mode == 'add') {
					this.promotion.pm_no = response.data.pm_no;
					this.promotions.unshift(_.cloneDeep(this.promotion));
				}
				//console.log(this.promotion);
				Object.assign(this.selectedPromotion, this.promotion);
			} else {
				this.$toast.error(data.msg);
			}

			this.mode = 'detail';
		},
		add() {
			this.mode = 'add';
			this.promotion = {};
			this.promotion.closed_yn = 'N';

			this.classes = [];
			//this.selectedItem = {};
			this.selectedPromotion = {};
		},
		async selectRow(pm) {
			//console.log(item);
			this.mode = 'detail';
			this.selectedPromotion = pm;

			this.promotion = _.cloneDeep(pm);

			await this.selectClasses(this.promotion.pm_no);
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectPromotions();
		},
		// #3312 4차 JC Classes Excel: 클릭 시점의 선택 프로모션(pm_no·제목)을 고정하고 저장된 Classes 를 다시 조회해 4열로 내려받는다.
		// 화면에서 편집 중(저장 전)인 추가·삭제·Promo Min 은 포함하지 않고 화면 classes 도 바꾸지 않는다. 조회가 실패하면 파일을 만들지 않는다.
		async excelClasses() {
			const pm_no = this.selectedPromotion.pm_no;
			if (this.mode == 'add' || !pm_no) {
				this.$toast.error('Please select a promotion');
				return false;
			}
			const title = this.selectedPromotion.title;
			const { data } = await apiSelectPromotionClassList({ pm_no: pm_no });
			const class_list = (data && data.classList) || [];
			if (!class_list.length) {
				this.$toast.error('No Data to Export.');
				return false;
			}
			const header = [
				{ key: 'class_code', name: 'Class Code', width: 18, dataType: defaultDataType.string },
				{ key: 'class_name', name: 'Class Name', width: 50, dataType: defaultDataType.string },
				{ key: 'item_min_price', name: 'Min Price', width: 12, dataType: defaultDataType.currency },
				{ key: 'promo_min_price', name: 'Promo Min', width: 12, dataType: defaultDataType.currency },
			];
			exportDataExcel(class_list, header, this.promotionFileName(title, pm_no));
		},
		// 파일명에 쓸 수 없는 문자는 '_' 로 바꾸고, 제목이 없으면 pm_no 를 쓴다.
		promotionFileName(title, pm_no) {
			const safe_title = String(title || '')
				.trim()
				.replace(/[\\/:*?"<>|]+/g, '_');
			return 'Promotion_' + (safe_title || pm_no);
		},
		async selectPromotions() {
			this.mode = 'detail';
			this.promotion = {};
			this.selectedPromotion = {};

			var param = {
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				closed_yn: this.closed_yn,
			};

			const { data } = await apiSelectPromotionList(param);

			//console.log(data);
			this.promotions = data.promotionList;
			this.list_count = data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);
			//this.$router.replace('/item/item_class?active_yn=' + this.active_yn + 'closed_yn=' + this.closed_yn + '&page_no=' + this.page_no).catch(err => err);

			//if (this.itemClasses.length > 0) this.selectRow(this.itemClasses[0]);
		},
		async selectClasses(pm_no) {
			const { data } = await apiSelectPromotionClassList({
				pm_no: pm_no,
			});

			//console.log(data);
			this.classes = data.classList;
		},
		async init() {
			//await this.index();
		},
	},
	created() {
		this.backUri = '/';

		this.$store.commit('setSideIndex', 3);
		this.$store.commit('setSelectedMenu', 'nav_li_promotion');
		this.$store.commit('setSubTitle', 'Sales -> Promotion');

		this.init();

		this.selectPromotions();
		//this.selectSalesGroups();
	},
	mounted() {},
};
</script>

<style></style>
